import React from "react";
import COUNTRY_COLORS from "../data/colors";
import { CATEGORY_META } from "../data/constants";

export default function Tooltip({ visible, x, y, country }) {
  if (!country) return null;
  const ft = Math.round(country.elevation * 3.28084);
  const cat = CATEGORY_META[country.category];

  // Smart positioning: keep tooltip away from cursor so it doesn't
  // block the peak dot or country underneath.
  // - Horizontally: offset 20px to the right (or left if near right edge)
  // - Vertically: show below cursor if in top third, above if in bottom two-thirds
  const vw = typeof window !== "undefined" ? window.innerWidth : 1200;
  const vh = typeof window !== "undefined" ? window.innerHeight : 800;
  const nearRight = x > vw - 240;
  const nearTop = y < 180;

  const style = {
    position: "fixed",
    left: nearRight ? x - 20 : x + 20,
    top: nearTop ? y + 20 : y - 10,
    transform: nearRight
      ? (nearTop ? "translate(-100%, 0)" : "translate(-100%, -100%)")
      : (nearTop ? "translate(0, 0)" : "translate(0, -100%)"),
  };

  return (
    <div className={`tt ${visible ? "v" : ""}`} style={style}>
      <div className="ttn">
        <div className="ttd" style={{ background: COUNTRY_COLORS[country.code] }} />
        {country.name}
      </div>
      <div className="ttp">{country.peak}</div>
      <div className="tte">
        {country.elevation.toLocaleString()}m{" "}
        <span style={{ fontWeight: 400, fontSize: 12, color: "var(--t2)" }}>/ {ft.toLocaleString()} ft</span>
      </div>
      <div className="ttc">{cat?.label} · {country.continent}</div>
    </div>
  );
}
